import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionDelegateAcceptPathParameters } from 'api/actions/revision-delegate-accept/revision-delegate-accept-path-parameters';
import { RevisionDelegateAcceptResponse } from 'api/actions/revision-delegate-accept/revision-delegate-accept-response';

type RevisionDelegateAcceptQueryParameters = Record<string, any>;

/**
 * The path of the RevisionDelegateAccept action.
 */
export const revisionDelegateAcceptActionPath = new SweetPath<keyof RevisionDelegateAcceptPathParameters>(
  '/api/revision/delegate-accept/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionDelegateAccept actions.
 */
export default function createRevisionDelegateAcceptAction(axios: AxiosInstance) {
  return function revisionDelegateAcceptAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionDelegateAcceptPathParameters;
    query?: RevisionDelegateAcceptQueryParameters;
  }) {
    const path = revisionDelegateAcceptActionPath.insert(parameters);

    return axios.request<RevisionDelegateAcceptResponse, RevisionDelegateAcceptResponse>({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
